export const doctor = {
	en: {
		singular: 'Doctor',
		plural: 'Doctors',
	},
	ar: {
		singular: 'طبيب',
		plural: 'أطباء',
	}
};
export const pharmacy = {
	en: {
		singular: 'Pharmacy',
		plural: 'Pharmacies',
	},
	ar: {
		singular: 'صيدلية',
		plural: 'صيدليات',
	}
};